import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "Playbooksstyle__Container"
})(["padding:10px;"]);